import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import {
  ActivityCard,
  ActivityText,
  DateLink,
  LoadMoreWrapper,
  NameLink,
  TimelineWrapper,
  TitleLink,
} from '@/common/timelineStyles';
import { Avatar } from '@/tables/AvatarNameCell';
import { usePagination } from '~/hooks/usePagination';
import { getPaginatedActivities } from '~/mockData';
import { WBSButton } from '~/modules/common/WBSButton';
export const Route = createFileRoute('/_app/_users/members/$memberId/activity')(
  {
    component: MemberActivityRoute,
  },
);
function MemberActivityRoute() {
  const { t } = useTranslation();
  const { items, isLoading, hasMore, loadMore } = usePagination(
    getPaginatedActivities,
  );

  return (
    <TimelineWrapper>
      {items.map((activity) => (
        <ActivityCard key={activity.id}>
          <Avatar src={activity.avatarUrl} alt={activity.studentName} />
          <ActivityText>
            {/* Translation Needed */}
            <NameLink to="/profile">{activity.studentName}</NameLink> has
            completed <TitleLink to="#">{activity.activityTitle}</TitleLink> and
            is <span className="status">{activity.status}</span>
            <DateLink to="#">{activity.submittedDate}</DateLink>
          </ActivityText>
        </ActivityCard>
      ))}
      {hasMore && (
        <LoadMoreWrapper>
          <WBSButton wide onClick={loadMore} isLoading={isLoading} alternate>
            {t('wbs.load-more')}
          </WBSButton>
        </LoadMoreWrapper>
      )}
    </TimelineWrapper>
  );
}
